import Vue from 'vue'
import Vuex from 'vuex'
import paintings from './modules/paintings'
import exhibitions from './modules/exhibitions'
import teaching from './modules/teaching'
import siteInfo from './modules/siteInfo'
import biography from './modules/biography'
import ui from './modules/ui'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        paintings,
        exhibitions,
        teaching,
        siteInfo,
        biography,
        ui,
    },

    actions: {
        async loadAllData({ dispatch }) {
            await Promise.all([
                dispatch('paintings/fetch'),
                dispatch('exhibitions/fetch'),
                dispatch('teaching/fetch'),
                dispatch('siteInfo/fetch'),
                dispatch('biography/fetch'),
            ])
        }
    }
})
